import { useContext } from 'react';

import { XYChartTruncationModeContext } from '../context/XYChartTruncationMode.context.js';
import { XYChartLegend } from '../types/xy-chart.js';

export const useXYChartTruncationMode = () => {
  const context = useContext(XYChartTruncationModeContext);

  if (context === undefined) {
    throw new Error(
      'useXYChartTruncationMode must be used within a XYChartTruncationModeContext',
    );
  }

  return context as Required<XYChartLegend>;
};
